module.exports = __webpack_public_path__ + "static/media/document-icon.0112fdb2.svg";